import React, { useState, useEffect } from "react";
import MenuButton from "./MenuButton";
import { Button, Text, Group, Stack, Box, Container, ActionIcon, Tooltip } from "@mantine/core";
import { IconMoon, IconSun } from '@tabler/icons-react';
import { useAccountStore } from "../zustand/account";
import { useObjectStore } from "../zustand/objects";
import { getStripeCheckoutURL } from "../api";
import {
  editorModalPrimaryButtonCompactStyles,
  getStoryboardChromeTheme,
} from "../styleFile";
import { getEditorChromeTheme, chromeActionIconStyles } from "../utils/editorChromeTheme";
import { CHROME_HEADER_HEIGHT, CHROME_ICON_HIT, CONTROL_RADIUS, SUBSCRIBE_BAR_HEIGHT } from "../utils/uiChromeTokens";


export default function AppNavBar({ pageName }) {
  const { viewportThemeOverride, toggleViewportThemeOverride } = useObjectStore();
  const isDark = viewportThemeOverride === "dark";
  const chrome = getEditorChromeTheme(isDark);
  const [themeHover, setThemeHover] = useState(false);
  const iconColour = { normal: chrome.icon, hover: chrome.iconHover };

  return (
    <Stack gap={0}>
      <Box
        style={{
          minHeight: CHROME_HEADER_HEIGHT,
          backgroundColor: chrome.bg,
          borderBottom: `1px solid ${chrome.border}`,
          boxShadow: chrome.headerShadow,
        }}
      >
        <Container size="xl" px={{ base: "md", sm: "lg" }}>
          <Group gap="sm" align="center" wrap="nowrap" style={{ minHeight: CHROME_HEADER_HEIGHT }}>
            <MenuButton pageName={pageName} iconColour={iconColour} />
            <Text
              fw={600}
              size="md"
              style={{
                minWidth: 0,
                letterSpacing: "-0.02em",
                color: chrome.title,
              }}
            >
              {pageName === "projects" ? "Projects" : pageName}
            </Text>
            <Tooltip label={isDark ? "Switch to light mode" : "Switch to dark mode"}>
              <ActionIcon
                size={CHROME_ICON_HIT}
                radius={CONTROL_RADIUS}
                variant="transparent"
                onPointerOver={() => setThemeHover(true)}
                onPointerLeave={() => setThemeHover(false)}
                onClick={toggleViewportThemeOverride}
                style={chromeActionIconStyles(themeHover, chrome)}
              >
                {isDark ? <IconMoon size={18} /> : <IconSun size={18} />}
              </ActionIcon>
            </Tooltip>
          </Group>
        </Container>
      </Box>
      <SubscribeReminderBar pageName={pageName} />
    </Stack>
  );
}

export const SubscribeReminderBar = ({ pageName } = {}) => {

      const {userStatus} = useAccountStore();
      const viewportThemeOverride = useObjectStore((s) => s.viewportThemeOverride);
      const isDarkBar = viewportThemeOverride === "dark";
      const barTheme = getStoryboardChromeTheme(isDarkBar);
      const [display, setDisplay] = useState("none")

      useEffect(() => {
            const planLimited = userStatus === 'loggedIn-none' || userStatus === 'loggedIn-canceled';
            const hideOnAccountSettings = pageName === 'Account Settings';
            setDisplay(planLimited && !hideOnAccountSettings ? 'flex' : 'none')
      },[userStatus, pageName])


      const handleSubscriptionClick = (label) => {
            getStripeCheckoutURL({
                success_url: 'https://mbxr.io/projects',
                cancel_url: 'https://mbxr.io/logging-out',
                subscription: label
            }).then((res) => window.location.replace(res.url))
      }

      return (
            <Box
                  display={display}
                  style={{
                        width: "100%",
                        boxSizing: "border-box",
                        height: SUBSCRIBE_BAR_HEIGHT,
                        alignItems: "center",
                        paddingLeft: 0,
                        paddingRight: 20,
                        backgroundColor: isDarkBar ? "#3a3529" : "#fff6e9",
                        borderBottom: `1px solid ${isDarkBar ? barTheme.cardBorder : "rgba(254,154,0,0.2)"}`,
                  }}
            >
                  <Group
                        justify="space-between"
                        align="center"
                        wrap="nowrap"
                        w="100%"
                        style={{ height: "100%" }}
                  >
                        <Group
                              gap={16}
                              wrap="nowrap"
                              style={{ flex: 1, minWidth: 0, height: "100%", alignItems: "center" }}
                        >
                              <Box
                                    style={{
                                          width: 4,
                                          height: "100%",
                                          borderRadius: 12,
                                          backgroundColor: "#fe9a00",
                                          flexShrink: 0,
                                    }}
                              />
                              <Text
                                    size="xs"
                                    style={{
                                          color: isDarkBar ? barTheme.bodyTextColor : "#5e5b57",
                                    }}
                              >
                                    You are on a limited free plan. Upgrade for more than one project.
                              </Text>
                        </Group>
                        <Button
                              size="xs"
                              variant="filled"
                              onClick={() => handleSubscriptionClick("pioneer")}
                              styles={editorModalPrimaryButtonCompactStyles}
                              style={{ flexShrink: 0, marginLeft: 16, paddingLeft: 16, paddingRight: 16 }}
                        >
                              Upgrade
                        </Button>
                  </Group>
            </Box>
      )
}